import { FunctionComponent, useEffect, useState } from "react"
import ProgressBar from '../ProgressBar/ProgressBar'
import AnteriorSiguienteButtons from '../AnteriorSiguienteButtons/AnteriorSiguienteButtons'
import HeaderImage from '../GenericStep/Header'
import step1 from '../../assets/img/step1.svg'
import store from '../../utils/store'

interface ContainerProps {
}

const Step1: FunctionComponent<ContainerProps> = (props) => {
    const [ selectedBarrio, setSelectedBarrio ] = useState( '' )
    const [ selectedResidencia, setSelectedResidencia ] = useState( '' )
    const [ selectedMotivo, setSelectedMotivo ] = useState( '' )
    const [ barrios, setBarrios ] = useState<any>()
    const [ residencia, setResidencia ] = useState<any>()
    const [ motivo, setMotivo ] = useState<any>()

    useEffect( () => {
        if ( selectedBarrio !== '' ) {
            store.setBarrio( selectedBarrio )
        }
        if ( selectedResidencia !== '' ) {
            store.setResidencia( selectedResidencia )
        }
        if ( selectedMotivo !== '' ) {
            store.setMotivo( selectedMotivo )
        }
    }, [ selectedBarrio, selectedMotivo, selectedResidencia ] )

    useEffect( () => {
        const popupShow = localStorage.getItem( 'popup' )
        if ( !popupShow ) {
            $( '#popup' ).modal('toggle')
        }
        store.getFirebaseCollection('barrios', ['enabled', '==', true]).then( ( barriosD: any ) => {
            setBarrios( barriosD )
        })
        store.getFirebaseCollection('residencia').then( ( residenciaD: any ) => {
            setResidencia( residenciaD )
        })
        store.getFirebaseCollection('motivo').then( ( motivoD: any ) => {
            setMotivo( motivoD )
        })
    }, [] )

    const onClickHandler = () => {
        localStorage.setItem( 'popup', 'false' )
    }

    const onCalleHandler = (e: any) => {
        const { value, name } = e.target
        store.setCalle(name, value)
    }

    return (
        <div className="body container-fluid">
            <div className="modal fade" id="popup">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title titulo" style={{fontSize: "40px", fontWeight: 600}}>Aclaración</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClickHandler}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body popup-contenedor">
                            Sr. Vecino, a través de la presente encuesta se le pide que brinde su opinión y valoración personal sobre distintos aspectos de la realidad barrial basada en el conocimiento que pudiera tener en función de su experiencia
                            de vida diaria. Esta encuesta no pretende que Ud. aporte información sobre la realidad de cada rincón particular del barrio, sino que opine según sea su percepción de la realidad barrial basada en los lugares que más
                            conozca del mismo. Se supone que cada vecino aporta una visión parcial de la realidad barrial y que ésta será más detallada a medida que se aproxime al lugar de localización de su vivienda o haga referencia a lugares que
                            frecuente habitualmente en el barrio.<br />
                            Desde esta premisa, las distintas opiniones de muchos vecinos, irán construyendo un panorama general, rico y complejo de todo el barrio.
                        </div>
                    </div>
                </div>
            </div>
            <HeaderImage image={step1}></HeaderImage>

            <div className="row justify-content-center">
                <div className="col-xs-8 col-sm-8 col-md-8 col-lg-4">
                    <div className="col-12 bottommargin centrar">
                        <span style={{ verticalAlign: "inherit" }}>
                            <span className="p">
                                <strong>Indique su barrio</strong>
                            </span>
                        </span>
                        <div className="dropdown">
                            <button
                                className="btn btn-primary dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                            >
                                <span style={{ verticalAlign: "inherit" }}>
                                    {selectedBarrio !== '' ? selectedBarrio : 'Por favor seleccione una opción'}
                                </span>
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                {barrios?.map( (b:any, index: number) =>
                                    <button className="dropdown-item" key={`barrio-${index}`} onClick={() => setSelectedBarrio( b.name )}>
                                        <span style={{ verticalAlign: "inherit" }}>
                                            <span style={{ verticalAlign: "inherit" }}>{b.name}</span>
                                        </span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-12 bottommargin centrar">
                        <span style={{ verticalAlign: "inherit" }}>
                            <span className="p">
                                <strong>Tiempo de residencia en el barrio</strong>
                            </span>
                        </span>
                        <div className="dropdown">
                            <button
                                className="btn btn-primary dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                            >
                                <span style={{ verticalAlign: "inherit" }}>
                                    {selectedResidencia !== '' ? selectedResidencia : 'Por favor seleccione una opción'}
                                </span>
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                {residencia?.map( (b: any, index: number) =>
                                    <button className="dropdown-item" key={`residencia-${index}`} onClick={() => setSelectedResidencia( b.name )}>
                                        <span style={{ verticalAlign: "inherit" }}>
                                            <span style={{ verticalAlign: "inherit" }}>{b.name}</span>
                                        </span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-12 centrar">
                        <span style={{ verticalAlign: "inherit" }}>
                            <span className="p">
                                <strong>Ubicación</strong>
                            </span>
                        </span>
                        <form>
                            <div className="form-group">
                                <input
                                    name='calle1'
                                    className="form-control mr-sm-2"
                                    type="text"
                                    placeholder="Ingrese el nombre de la calle"
                                    onChange={onCalleHandler}
                                />
                            </div>
                        </form>
                    </div>

                    <div className="col-12 bottommargin centrar">
                        <form>
                            <div className="form-group">
                                <input
                                    name='calle2'
                                    className="form-control mr-sm-2"
                                    type="text"
                                    placeholder="Ingrese las calles que la cortan"
                                    onChange={onCalleHandler}
                                />
                            </div>
                        </form>
                    </div>

                    <div className="col-12 bottommargin centrar">
                        <span style={{ verticalAlign: "inherit" }}>
                            <span className="p">
                                <strong>¿Cuál es el motivo de su participación?</strong>
                            </span>
                        </span>
                        <div className="dropdown">
                            <button
                                className="btn btn-primary dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                            >
                                <span style={{ verticalAlign: "inherit" }}>
                                    {selectedMotivo !== '' ? selectedMotivo : 'Por favor seleccione una opción'}
                                </span>
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                {motivo?.map( (b:any, index: number) =>
                                    <button className="dropdown-item" key={`motivo-${index}`} onClick={() => setSelectedMotivo( b.name )}>
                                        <span style={{ verticalAlign: "inherit" }}>
                                            <span style={{ verticalAlign: "inherit" }}>{b.name}</span>
                                        </span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-xs-8 col-sm-8 col-md-8 col-lg-4 alert alert-info" role="alert">
                    <b>Nota importante:</b> Las banderitas rojas que verá en las próximas pantallas indican que, si lo desea, podrá ubicar dichas opciones de respuesta dentro de un mapa del barrio.
                </div>
            </div>
            <AnteriorSiguienteButtons linkAnterior={"/"} linkSiguiente="/step2"></AnteriorSiguienteButtons>
            <ProgressBar progress={5}></ProgressBar>
        </div>
    )
}
export default Step1;